const NotFound = () => {
    return (
        <h1 className="close-text">The page you are looking for is not found.</h1>
    );
}

export default NotFound;